import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import confetti from 'canvas-confetti';
import {
  Container,
  BoxConfirmEmailAddress,
  Chip,
  TitleConfirmEmailAddress,
} from './SignUpForms.styled';
import './SignUpForms.css';
import { Hidden } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import {
  SuccessMessage,
  InstructionText,
  EmailHighlight,
  EmailIconWrapper,
  StepsIndicator,
  ActionSection,
  FooterSection,
  FooterLink,
  HelpText,
  ConfirmEmailButton,
} from '../Onboarding/Onboarding.styled';

export const ConfirmEmailAddress = ({ registeredEmail = '' }) => {
  const { t } = useTranslation();

  const getConfirmationMessage = () => {
    const partA = t('RegisterForm.confirmEmailAddress.finishRegisterPartA');
    const partB = t('RegisterForm.confirmEmailAddress.finishRegisterPartB');

    return (
      <>
        {partA}
        <EmailHighlight>{registeredEmail}</EmailHighlight>
        {partB}
      </>
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57'],
        gravity: 0.8,
        ticks: 200,
      });
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container>
      <BoxConfirmEmailAddress>
        <Chip>{t('RegisterForm.chip.signUp')}</Chip>

        <TitleConfirmEmailAddress>
          {t('RegisterForm.confirmEmailAddress.title')}
        </TitleConfirmEmailAddress>

        <SuccessMessage variant="h6" component="div">
          {t('RegisterForm.confirmEmailAddress.thanksMessage')}
        </SuccessMessage>

        <EmailIconWrapper>
          <EmailIcon />
        </EmailIconWrapper>

        <InstructionText variant="body1" component="div">
          {getConfirmationMessage()}
        </InstructionText>

        <StepsIndicator>
          <strong>{t('RegisterForm.confirmEmailAddress.nextSteps')}</strong>
          <br />
          1. {t('RegisterForm.confirmEmailAddress.step1')}
          <br />
          2. {t('RegisterForm.confirmEmailAddress.step2')}
          <br />
          3. {t('RegisterForm.confirmEmailAddress.step3')}
        </StepsIndicator>

        <ActionSection>
          <a
            href="https://enterprise.shapya.com/"
            style={{ textDecoration: 'none' }}
            aria-label={t('RegisterForm.alreadyAccount.login')}>
            <ConfirmEmailButton>
              {t('RegisterForm.alreadyAccount.login')}
            </ConfirmEmailButton>
          </a>
        </ActionSection>

        <FooterSection>
          <FooterLink
            href="https://shapya.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="ShapYa Suite Homepage">
            ShapYa inc. | ShapYa Suite
          </FooterLink>

          <Hidden xsUp>
            <HelpText variant="body2" component="div">
              {t('RegisterForm.confirmEmailAddress.needHelp')}&nbsp;
              <FooterLink
                href="https://shapya.com/terms/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('RegisterForm.confirmEmailAddress.helpCenter')}>
                {t('RegisterForm.confirmEmailAddress.helpCenter')}
              </FooterLink>
            </HelpText>
          </Hidden>
        </FooterSection>
      </BoxConfirmEmailAddress>
    </Container>
  );
};

ConfirmEmailAddress.propTypes = {
  registeredEmail: PropTypes.string,
};
